export default "__VITE_ASSET__CxHtcIyI__"